import { useCallback, useEffect, useState } from "react";

export function useResource<Value>(loader: () => Promise<Value>, dependencies: readonly unknown[]) {
  const [data, setData] = useState<Value>();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    setError(undefined);
    try { setData(await loader()); }
    catch (cause) { setError(cause instanceof Error ? cause.message : "The data could not be loaded."); }
    finally { setLoading(false); }
  }, dependencies);
  useEffect(() => { void load(); }, [load]);
  return { data, error, loading, reload: load };
}
